import React from 'react'
import styles from './info-box.module.css'
import { Link } from 'gatsby'

const InfoBox = () => (
  <div className={styles.wrapper}>
    <div className={styles.container}>
      <div className={styles.leftBox}>
        <p className={styles.heading}>Saving UK businesses time & money</p>
        <p className={styles.subHeading}>We compare multiple trusted energy suppliers across the entire market, ensuring you get the best deal for your business.</p>
        <p>By working with the UK’s leading energy brokers we will secure the best possible tariff on your commercial gas and electricity.</p>
        <p>With some basic information about your business you can easily <Link to={'#form'}>compare business energy</Link> and choose the right plan for you. See how much you could save on your business energy today.</p>
      </div>
      <div className={styles.rightBox}>
        <p className={styles.subHeading}>SwitchPal - Compare, Switch & Save</p>
        <hr className={styles.divider}/>
        <ul>
          <li>Stop overpaying for your business gas and electricity</li>
          <li>We compare multiple energy providers across the market</li>
          <li>We find you the best deals and prices for your commercial gas and electricity</li>
          <li>Switching energy supplier is quick, simple and easy</li>
        </ul>
      </div>
    </div>
  </div>
)

export default InfoBox
